import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-white/40">Loading…</div>;
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}
